import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { requestModal } from '../../stores/mainSlice';

import i18n from 'i18n-js';

import Filter from "../components/basic/Filter";
import { FlatList, useWindowDimensions } from "react-native";
import { ContactCard, ContactCardHeader } from "../components/basic/ContactCard";

import { ModalMaster } from '../components/modals/ModalWrapper/ModalMaster';

export default function Channels() {
  const dispatch = useDispatch();
  const dim = useWindowDimensions();
  const [search, setSearch] = useState('');

  const all_entries = useSelector((state) => state.contacts.channels).map((state) => {
    return {
      channel: {
        id: state.id,
        name: state.name,
        description: i18n.t('studio.channel.membersN', { num: (state.contacts ?? []).length }),
        channelImage: { id: state.channelImage?.id }
      },
      context: [
        {
          name: i18n.t('channel.update'),
          callback: () => {
            dispatch(requestModal({
              type: 'channel:update',
              option: { channel: { id: state.id } }
            }));
          }
        },
        {
          name: i18n.t('channel.deleteChannel'),
          action: 'negative',
          callback: () => {
            dispatch(requestModal({
              type: 'channel:remove',
              option: { channel: { id: state.id } }
            }));
          }
        }
      ]
    }
  });

  const render_contacts_entry = ({ item, _index }) => {
    return <ContactCard entry={item} />;
  }

  const render_contacts_entry_header = ({ }) => {
    return (
      <ContactCardHeader
        icon={{ name: 'campaign' }}
        subicon={{ name: 'add-circle' }}
        callback={() => {
          dispatch(requestModal({
            type: 'channel:create',
            option: {}
          }));
        }} />
    );
  }

  const filtered_entries = (!search ? all_entries : all_entries.filter((entry) => {
    let searchable = '';

    searchable += entry.channel.name;
    searchable += entry.channel.description;

    return searchable.toLowerCase().includes(search.toLowerCase());
  })).sort((a, b) => {
    return a.channel.name > b.channel.name ? 1 : -1;
  });

  return (
      <View className="flex-1">
          <VStack className="flex-1 h-[100%] pt-9 px-10 pb-9 items-center overflow-y-scroll overflow-x-clip">
              <VStack space="2xl" className="max-w-[100%] w-[1100px]">
                  <Text className="text-2xl font-[700] text-secondary-900 ml-2 mb-2">{i18n.t('contact.channelsN', { num: all_entries.length })}</Text>
                  <Filter search={search} setSearch={setSearch} />
                  <FlatList 
                    data={filtered_entries} 
                    keyExtractor={(entry) => entry?.channel.id} 
                    contentContainerStyle={{ flexDirection: 'row', flexWrap: 'wrap' }} 
                    renderItem={render_contacts_entry} 
                    ListHeaderComponent={render_contacts_entry_header} />
              </VStack>
          </VStack>
          <ModalMaster />
      </View>
  );
}
